module.exports = __webpack_public_path__ + "img/newProcessSignatureLogo.5a661261.svg";